import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexHome from '../views/IndexHome.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'indexHome',
    component: IndexHome
  },
  {
    path: '/index',
    name: 'IndexHome',
    component: () => import(/* webpackChunkName: "about" */ '../views/IndexHome.vue'),
    meta: {
      keepAlive: true,
      componentName: 'IndexHome'
    }
  },
  {
    path: '/gameDetail',
    name: 'GameDetail',
    component: () => import('../views/gameDetail.vue'),
    meta: {
      keepAlive: true,
      componentName: 'GameDetail'
    }
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('../views/my.vue'),
    meta: {
      keepAlive: true,
      componentName: 'My'
    }
  },
  {
    path: '/newGame',
    name: 'NewGame',
    component: () => import('../views/newGame.vue'),
    meta: {
      keepAlive: true,
      componentName: 'NewGame'
    }
  },
  {
    path: '/reserveGame',
    name: 'ReserveGame',
    component: () => import('../views/reserveGame.vue'),
    meta: {
      keepAlive: true,
      componentName: 'ReserveGame'
    }
  },
  {
    path: '/rankingGame',
    name: 'RankingGame',
    component: () => import('../views/rankingGame.vue'),
    meta: {
      keepAlive: true,
      componentName: 'RankingGame'
    }
  },
  {
    path: '/messageDetail',
    name: 'MessageDetail',
    component: () => import('../views/messageDetail.vue'),
    meta: {
      keepAlive: true,
      componentName: 'MessageDetail'
    }
  },
  {
    path: '/gameCoupon',
    name: 'GameCoupon',
    component: () => import('../views/gameCoupon.vue'),
    meta: {
      keepAlive: true,
      componentName: 'GameCoupon'
    }
  },
  {
    path: '/gameGift',
    name: 'GameGift',
    component: () => import('../views/gameGift.vue'),
    meta: {
      keepAlive: true,
      componentName: 'GameGift'
    }
  },
  {
    path: '/gameRebate',
    name: 'GameRebate',
    component: () => import('../views/gameRebate.vue'),
    meta: {
      keepAlive: true,
      componentName: 'GameRebate'
    }
  },
  {
    path: '/gameEmpty',
    name: 'GameEmpty',
    component: () => import('../views/gameEmpty.vue'),
  },
  {
    path: '/h5Game',
    name: 'h5Game',
    component: () => import('../views/h5Game.vue'),
  },
  {
    path: '/cloudGaming',
    name: 'CloudGaming',
    component: () => import('../views/cloudGaming/index.vue'),
  },
  {
    path: '/cloudGaming2',
    name: 'CloudGaming2',
    component: () => import('../views/cloudGaming2/index.vue'),
  },
]

const router = new VueRouter({
  routes
})

export default router
